<div class="menu-wrap">
  <div class="user-image">
    <img *ngIf="userImage !== undefined" [src]="userImage" class="img" alt="User Image" />
    <img *ngIf="userImage == undefined" src="assets/images/icons/user.svg" class="img" />
  </div>
  <button class="edit-icon">
    <label for="input-file">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M12.9612 1.12195C12.6438 1.12195 12.3396 1.24853 12.1154 1.47361L11.2704 2.32175L12.9612 4.01903L13.8071 3.1699C13.9182 3.05845 14.0062 2.92619 14.0662 2.78067C14.1263 2.63516 14.1572 2.47922 14.1572 2.32175C14.1572 2.16429 14.1263 2.00835 14.0662 1.86284C14.0062 1.71732 13.9182 1.58506 13.8071 1.47361C13.6961 1.36217 13.5643 1.27373 13.4191 1.21337C13.274 1.15302 13.1184 1.12195 12.9612 1.12195ZM14.596 3.96373C14.8107 3.74817 14.9811 3.49222 15.0973 3.21048C15.2136 2.92874 15.2734 2.62675 15.2734 2.32175C15.2734 2.01676 15.2136 1.71477 15.0973 1.43303C14.9811 1.15129 14.8107 0.895342 14.596 0.679779C14.3812 0.464217 14.1263 0.293262 13.8459 0.176639C13.5654 0.0600159 13.2648 0 12.9612 0C12.3482 0 11.7602 0.244443 11.3265 0.679779L10.0865 1.9245C10.0863 1.92478 10.086 1.92505 10.0857 1.92533L0.990606 11.0553C0.918987 11.1272 0.868168 11.2173 0.843589 11.316L0.0167162 14.6361C-0.0308896 14.8273 0.0247811 15.0295 0.163371 15.1689C0.301961 15.3083 0.503147 15.3643 0.693361 15.3166L4.00085 14.4866C4.09894 14.462 4.18853 14.411 4.26006 14.3392L14.596 3.96373ZM12.1714 4.81187L10.4806 3.1146L1.8889 11.7392L1.32546 14.0016L3.58054 13.4357L12.1714 4.81187ZM7.44187 14.7723C7.44187 14.4625 7.69175 14.2114 8.00001 14.2114H15.4419C15.7501 14.2114 16 14.4625 16 14.7723C16 15.0822 15.7501 15.3333 15.4419 15.3333H8.00001C7.69175 15.3333 7.44187 15.0822 7.44187 14.7723Z"
          fill="white" />
      </svg>
    </label>
    <input type="file" #fileInput (change)="onFileChange($event)" id="input-file"/>
  </button>
  <h4 class="sec-title">
    Hi <span class="username">{{ userName }}</span>
  </h4>
  <ul class="menu-item-wrap list-unstyled mb-0">
    <li>
      <a [routerLink]="'/account/posts'" [routerLinkActive]="'active'" class="item">My Posts</a>
    </li>
    <li>
      <a [routerLink]="'/account/transaction'" [routerLinkActive]="'active'" class="item">Order History</a>
    </li>
    <li>
      <a [routerLink]="'/account/profile'" [routerLinkActive]="'active'" class="item">My Profile</a>
    </li>
    <li>
      <a [routerLink]="'/account/my-request'" [routerLinkActive]="'active'" class="item">My Request</a>
    </li>
    <li>
      <a [routerLink]="'/account/following'" [routerLinkActive]="'active'" class="item">Following</a>
    </li>
    <li>
      <a [routerLink]="'/account/probo'" [routerLinkActive]="'active'" class="item">Bharat.OX</a>
    </li>
  </ul>
</div>
<div class="bottom-text-wrap">
  <p class="small-text">
    You are currently using
    <b>{{
      plan == "free"
      ? "Free Plan"
      : plan == "plan_advance"
      ? "Advance Plan"
      : "Premium Plan"
      }}</b>
  </p>
  <button *ngIf="plan == 'plan_advance' || plan == 'free'" class="btn btn-darkblue-bg" [routerLink]="['/prices']">
    Upgrade Now
  </button>
</div>
